const steps = [
  {
    number: '01',
    icon: 'ri-coins-line',
    title: 'Ingresa el Monto',
    description:
      'Escribe cuánto deseas enviar en dólares. Nuestra calculadora muestra al instante cuánto recibirá tu familia.',
    color: 'bg-green-600',
  },
  {
    number: '02',
    icon: 'ri-bar-chart-grouped-line',
    title: 'Compara las Opciones',
    description:
      'Ve de un vistazo las tasas de cambio, comisiones y tiempo de entrega de cada servicio. Ordenados del mejor al peor.',
    color: 'bg-emerald-500',
  },
  {
    number: '03',
    icon: 'ri-send-plane-fill',
    title: 'Elige y Envía',
    description:
      'Haz clic en "Enviar Ahora" junto al servicio que prefieras y serás llevado directamente para completar tu envío.',
    color: 'bg-teal-600',
  },
];

export default function HowItWorks() {
  return (
    <section id="como-funciona" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block bg-green-100 text-green-700 text-xs font-semibold px-3 py-1 rounded-full mb-4 uppercase tracking-wider">
            Proceso Simple
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            ¿Cómo Funciona RemesasVE?
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto">
            En solo 3 pasos encontrarás el mejor precio para enviar dinero a Venezuela. Sin registro, sin complicaciones.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {/* Connector lines (desktop) */}
          <div className="hidden md:block absolute top-12 left-1/3 right-1/3 h-px bg-gradient-to-r from-green-200 via-green-300 to-green-200 z-0" />

          {steps.map((step, idx) => (
            <div
              key={idx}
              className="relative z-10 flex flex-col items-center text-center group"
            >
              <div className="relative mb-6">
                <div
                  className={`w-20 h-20 rounded-2xl ${step.color} flex items-center justify-center transition-transform group-hover:-translate-y-1 duration-300`}
                >
                  <span className="w-8 h-8 flex items-center justify-center">
                    <i className={`${step.icon} text-white text-3xl`} />
                  </span>
                </div>
                <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-white border-2 border-green-200 flex items-center justify-center">
                  <span className="text-green-700 text-xs font-extrabold">{step.number}</span>
                </div>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">{step.title}</h3>
              <p className="text-gray-500 leading-relaxed text-sm max-w-xs">{step.description}</p>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center bg-green-50 rounded-2xl p-10">
          <div className="flex flex-col md:flex-row items-center justify-center gap-6">
            <div className="text-left max-w-md">
              <h3 className="text-xl font-bold text-gray-900 mb-2">¿Listo para ahorrar en tu próxima remesa?</h3>
              <p className="text-gray-500 text-sm">Miles de venezolanos ya usan RemesasVE para encontrar la mejor tasa cada semana.</p>
            </div>
            <button
              onClick={() => document.getElementById('comparar')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-green-600 hover:bg-green-700 text-white font-bold px-8 py-3.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              Comparar Ahora &rarr;
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
